import { useEffect, useState } from 'react';
import { endpoints } from '../api/client.js';
import Modal from './Modal.jsx';

export default function PromoteDialog({ open, onClose, siteName, previewVersion, liveVersion, onPromoted }) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) setError(null);
  }, [open]);

  async function confirm() {
    setPending(true);
    setError(null);
    try {
      await endpoints.promoteSite(siteName);
      // Dismiss first: onPromoted triggers a refetch that can re-render this
      // subtree, so the close should not depend on what happens during it.
      onClose();
      onPromoted();
    } catch (err) {
      setError(err?.message || 'Promotion failed.');
    } finally {
      setPending(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      eyebrow="Deployment slots"
      title={`Promote ${siteName} to live?`}
      footer={
        <>
          <button type="button" className="btn btn--quiet" onClick={onClose} disabled={pending}>Cancel</button>
          <button type="button" className="btn btn--primary" onClick={confirm} disabled={pending || !previewVersion}>
            {pending ? 'Promoting…' : 'Confirm promotion'}
          </button>
        </>
      }
    >
      <p className="state__body">
        This flips the live symlink to the exact release already reviewed on preview. No build or
        artifact copy occurs.
      </p>
      <div className="promote-flow mono">
        <span>preview {previewVersion || 'nothing deployed'}</span>
        <span aria-hidden="true">→</span>
        <span>live {liveVersion || 'nothing deployed'}</span>
      </div>
      {error ? <p className="notice notice--error" role="alert">{error}</p> : null}
    </Modal>
  );
}
